"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectPromise = connectPromise;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _ = require("_");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _generalStore = require("general-store");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _LoadingStatus = require("./LoadingStatus");

var _defer = _interopRequireDefault(require("q/js/lib/defer"));

function _enforceIsLoading(isLoading) {
  (0, _invariant.default)(typeof isLoading === 'function', 'connectPromise: Expected param `isLoading` to be type function but got `%s`', (0, _typeof2.default)(isLoading));
}

function someFieldsLoading(isLoading, state) {
  return Object.keys(state).some(function (field) {
    return isLoading(state[field]);
  });
}

function makePromise(connector, isLoading, props) {
  var deferred = (0, _defer.default)();
  connector(function (error, state, prevState, remove) {
    if (error) {
      deferred.reject(error);
      return;
    }

    if (someFieldsLoading(isLoading, state)) {
      return;
    }

    remove();
    deferred.resolve(state);
  }, props);
  return deferred.promise;
}
/**
 * Similar to `GeneralStore.connect`, accepts an object of Stores and/or
 * dependency objects and returns a function which (instead of wrapping a react
 * component) returns a promise to the data described in the dependency.
 *
 *
 * @example
 * import UserStore from 'crm_data/user/UserStore';
 * const fetchUser = connectPromise({userData: UserDataStore});
 *
 *
 * By default, the promise resolves once deref() !== LOADING. The optional
 * `isLoading` param allows you to specify a custom resolution test.
 *
 *
 * @example
 * import CustomLoadingStore from 'CustomLoadingStore';
 * const fetchCustomData = connectPromise(
 *   {custom: CustomLoadingStore},
 *   (data) => data.loading
 * );
 *
 *
 * You can also parameterize the fetcher by passing "props" to the fetcher.
 *
 * @example
 * import { connectPromise } from 'crm_data/flux/connectPromise';
 * import PropertiesStore from 'crm_data/properties/PropertiesStore';
 *
 * const fetchProperties({
 *   properties: {
 *     stores: [PropertiesStore],
 *     deref({objectType}) {
 *       return PropertiesStore.get(objectType);
 *     },
 *   },
 * });
 *
 * // then to fetch Contact properties...
 * fetchProperties({objectType: 'CONTACT'}).then(({properties}) => ...);
 *
 *
 * It's intended to be 100% compatible with the shared "dependency" definitions,
 * like `SubjectDependency`, that we use in component land.
 *
 *
 * @example
 * import SubjectDependency
 *   from 'crm_ui/flux/dependencies/SubjectDependency';
 *
 * const fetchSubject = connectPromise({subject: SubjectDependency});
 *
 * fetchSubject({
 *   objectType: 'CONTACT',
 *   subjectId: '123456'
 * }).then(
 *   ({subject}) => ...
 * );
 *
 *
 * @param  {object} dependecy object or a Store
 * @param  {?function} isLoading test that returns true until the data is loaded
 * @return {function}
 */


function connectPromise(dependencies) {
  var isLoading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _LoadingStatus.isLoading;
  var dispatcher = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _dispatcher.default;

  _enforceIsLoading(isLoading);

  return (0, _.partial)(makePromise, (0, _generalStore.connectCallback)(dependencies, dispatcher), isLoading);
}